import { render } from "./About.vue?vue&type=template&id=55f07755"
const script = {}
script.render = render

export default script